<template>
  <div>
    <router-view v-if="$store.getters.loadCompleted" />
    <!--Loading效果-->
    <loading />
    <!--提醒訊息-->
    <notice />
    <request />
    <!--廣告彈窗-->
    <commercial />
    <!-- cookie policy -->
    <cookie-agree v-if="$store.getters.loadCompleted" />
  </div>
</template>
<script>
import Vue from 'vue'
import Loading from '@/components/loading'
import Notice from '@/components/modal/notice'
import Request from '@/components/modal/request'
import Commercial from '@/components/modal/commercial'
import { forceApp, showNotice } from '@/utils/tool'
import CookieAgree from '@/components/cookieAgree'

export default {
  name: 'App',
  components: {
    Loading,
    Notice,
    Request,
    Commercial,
    CookieAgree
  },
  data() {
    return {

    }
  },
  watch: {
    $route: function(to, from, next) {
      if (forceApp(to.name, this.$store.getters.permissionInfo.mobile_force_app)) {
        const self = this
        setTimeout(function() { window.location = self.$store.getters.urlInfo.appDownloadUrl }, 5000)
        showNotice(this.$t('Bao.downAppNotice'), function() {
          window.location = self.$store.getters.urlInfo.appDownloadUrl
        })
      }
    }
  },
  mounted() {
    if (this.$store.getters.token) {
      Vue.prototype.$socket.init()
    }
  },
  beforeDestroy() {

  },
  methods: {

  }
}
</script>
<style scoped>
</style>
